import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-annual-reports',
  templateUrl: './annual-reports.component.html',
  styleUrls: ['./annual-reports.component.scss']
})
export class AnnualReportsComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

  
}
